import React from "react";
import PropTypes from "prop-types";
import HighchartsReact from "highcharts-react-official";

const Highcharts = window.Highcharts;

function UsedInventoryConversionBar({ data }) {
  const chartDataLeads = data.map((data) => [data.leads]);
  const chartDataCalls = data.map((data) => [data.calls]);
  const chartDataChats = data.map((data) => [data.chats]);
  const chartDataX = data.map((data) => [data.make]);

  const chartOptions = {
    chart: {
      type: "bar",
      backgroundColor: "#f2f2ff",
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "Top 10 Used Vehicle Conversions",
      style: {
        fontWeight: "bold",
        fontSize: "14",
      },
    },
    subtitle: {
      text: null,
    },
    xAxis: {
      categories: chartDataX,
    },
    legend: {
      layout: "vertical",
      align: "right",
      verticalAlign: "top",
      x: -40,
      y: 80,
      floating: true,
      borderWidth: 1,
      backgroundColor: "#FFFFFF",
      shadow: true,
    },
    yAxis: {
      type: "logarithmic",
      title: {
        text: null,
      },
    },
    plotOptions: {
      column: {
        dataLabels: {
          enabled: false,
        },
        enableMouseTracking: true,
      },
    },
    series: [
      {
        name: "Calls",
        data: chartDataCalls,
      },
      {
        name: "Chats",
        data: chartDataChats,
      },
      {
        name: "Leads",
        data: chartDataLeads,
      },
    ],
  };

  return (
    <div className="col-md-6 col-xs-12">
      <div style={{ height: "400px" }}>
        <HighchartsReact highcharts={Highcharts} options={chartOptions} />
      </div>
    </div>
  );
}

UsedInventoryConversionBar.propTypes = {
  data: PropTypes.array.isRequired,
};

export default UsedInventoryConversionBar;
